import { ConnectionDetail } from './ConnectionDetail';
import {
  DataSourceItemOptional,
  FlowItemOptional,
  IIdItem,
  IUpdatedItem
} from './resourceParts';

export interface IDataConnectionType {
  connectionTypeDisplayName: string;
  connectionType: string;
}

export interface IDataConnectionProperties extends IDataConnectionType {
  connectionDetails: ConnectionDetail; // The specific subtype of this object depends on the connectionDetails.type (see ConnectionDetail.ts)
  connectionTypeEditable: boolean;
  connectionOAuth: boolean;
}

//TODO Figure out a way to remove the dependency on this variable and then remove it
export let DataConnectionTypeKeys = {
  connectionTypeDisplayName: 'connectionTypeDisplayName',
  connectionType: 'connectionType'
};

export type IDataConnection =
  IDataConnectionProperties &
  DataSourceItemOptional &
  FlowItemOptional &
  IIdItem &
  IUpdatedItem;
